// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3PYgr","label":"SetPasswdForm_label__Rbee_"};